module.exports = __webpack_public_path__ + "img/banner-call-center.af37e58a.png";